import React from 'react'
import Proptypes from 'prop-types'
import { getMicrositeBase } from '../../../utils/common-utils'

/**
 * Used with the basic footer in microsite-footer-nav.ftl
 * @returns
 */
const FooterNavigation = props => {
  const { navItems } = props

  return (
    <>
      {navItems &&
        navItems.map(item => {
          return (
            <li className='ms-listItem' key={item.text}>
              <a
                className='u-textColorDefault u-padding1gu u-linkClean'
                href={
                  item.text === 'Sitemap' && getMicrositeBase()
                    ? `${getMicrositeBase()}/sitemap`
                    : item.Link[0].string
                }>
                {item.text}
              </a>
            </li>
          )
        })}
    </>
  )
}
FooterNavigation.propTypes = {
  navItems: Proptypes.array,
}
export default FooterNavigation
